import * as React from 'react';
import { Svg, Path, Circle } from 'react-native-svg';
import { memo } from 'react';
import type { IconProps } from '../helpers/icon-props';

const Icon = (props: IconProps) => {
  const { size = 24, ...otherProps } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 512 512" {...otherProps}>
      <Path
        d="M0 256C0 114.616 114.616 0 256 0s256 114.616 256 256c-11.13 0-256 33.391-256 33.391z"
        fill="#f0f0f0"
      />
      <Path
        d="M512 256c0 141.384-114.616 256-256 256S0 397.384 0 256"
        fill="#d80027"
      />
      <Circle cx={178.087} cy={256} r={122.435} fill="#f0f0f0" />
      <Path
        d="M55.652 256c0-67.617 54.816-122.435 122.435-122.435 67.62 0 122.435 54.817 122.435 122.435"
        fill="#d80027"
      />
    </Svg>
  );
};
Icon.displayName = 'Greenland';
export const Greenland = memo<IconProps>(Icon);
